const apiUrl = 'https://tiny-ruby-dolphin-sock.cyclic.app/api/';



export {apiUrl}